import { RootState } from '@/Redux/RootReducer';

const backgroundTasks = (state: RootState) => state?.backgroundTasks?.tasks || [];

export const backgroundTasksSelectors = {
  backgroundTasks,
};
